import React, { useEffect } from 'react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title = 'Send Certificates', message = 'Confirm to send certificates to all attendees?', isLoading = false }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900 bg-opacity-30 flex justify-center items-center z-50 transition-opacity duration-300 warning-alert-card">
      <div className="bg-white rounded shadow-lg p-6 text-center w-[500px] transform transition-all duration-300 warning-card">
        <div className="flex justify-center mb-4">
          <span className="warnning-icons"><img src="/warningtick.png" alt="" /></span>
        </div>
        <h2 className="text-2xl font-bold text-gray-700 mb-4">{title}</h2>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex justify-center gap-4">
          <button
            style={{ backgroundColor: '#7066E0' }}
            className="text-white px-6 py-2 rounded hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-purple-500 disabled:brightness-90 disabled:cursor-not-allowed"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin h-5 w-5 mr-2 text-white" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Loading...
              </span>
            ) : (
              'Yes'
            )}
          </button>
          <button
            className="bg-gray-400 text-white px-6 py-2 rounded hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500"
            onClick={onClose}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;